import { FlagCheckeredIcon } from './FlagCheckeredIcon';

/**
 * author: Austin Andrews
 * id B7386AC8-4DBF-4948-AD45-49234A8A019B
 * name flag-checkered
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag-checkered.svg
 * tags
 * - Sport 
 */
export const GoalIcon = FlagCheckeredIcon;
export default GoalIcon